import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Image,
  Pressable,
  ScrollView,
  Input,
  Button,
  TextArea,
  Center,
  IconButton,
  ChevronUpIcon,
  useToast,
  Spinner,
  Icon,
} from "native-base";
import { Modal } from "react-native";
import Svg, { Path, Rect, Polyline } from "react-native-svg";
import { GlobalStyles } from "../../constants/styles";
import Toast from "../Toast";
import { useSelector } from "react-redux";
import axios from "axios";
import * as DocumentPicker from "expo-document-picker";
import * as ImagePicker from "expo-image-picker";
import { GlobalConstants } from "../../constants/constants";
import { Ionicons } from "@expo/vector-icons";


// const buildApiUrl = (baseUrl, port, endpoint) => {
//   const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
//   return `${cleanBaseUrl}:${port}${endpoint}`;
// };

// const EMAIL_API_BASE_URL = buildApiUrl(
//   GlobalConstants.servicesBaseUrl,
//   "3006",
//   "/api",
// );

const EMAIL_API_BASE_URL = `${GlobalConstants.EmailBaseUrl}`.replace(/\/$/, "") + "/api";
// const EMAIL_API_BASE_URL =
//   "http://ec2-3-96-139-52.ca-central-1.compute.amazonaws.com:3006/api";

const createFileBlob = async (fileUri, fileName, mimeType) => {
  try {
    const response = await fetch(fileUri);
    const blob = await response.blob();
    return new File([blob], fileName, { type: mimeType || "text/csv" });
  } catch (error) {
    throw error;
  }
};

const CustomCheckbox = ({
  size = 20,
  color = GlobalStyles.colors.blue,
  checked = true,
}) => {
  const strokeWidth = 2.2;
  const corner = 4;
  const box = size;

  return (
    <Svg width={box} height={box} viewBox={`0 0 ${box} ${box}`}>
      <Rect
        x={strokeWidth / 2}
        y={strokeWidth / 2}
        width={box - strokeWidth}
        height={box - strokeWidth}
        rx={corner}
        ry={corner}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      {checked && (
        <Polyline
          points={`${box * 0.27},${box * 0.58} ${box * 0.45},${box * 0.74}
           ${box * 0.75},${box * 0.32}`}
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      )}
      <Path
        d={`M ${box * 0.2} ${box - strokeWidth} H ${box * 0.8}`}
        stroke={color}
        strokeWidth={strokeWidth * 0.5}
        strokeLinecap="round"
      />
    </Svg>
  );
};

const Table = ({ children }) => (
  <Box
    w="100%"
    borderWidth={1}
    borderColor={GlobalStyles.colors.tableBorder}
    borderRadius={0}
  >
    {children}
  </Box>
);

const Thead = ({ children, bg }) => <Box bg={bg}>{children}</Box>;
const Tbody = ({ children }) => <Box>{children}</Box>;

const Tr = ({ children, bg, isLast }) => (
  <HStack
    bg={bg}
    borderBottomWidth={isLast ? 0 : 1}
    borderBottomColor={GlobalStyles.colors.tableBorder}
  >
    {children}
  </HStack>
);

const Th = ({ children, flex = 1 }) => (
  <Box flex={flex} p={2}>
    {children}
  </Box>
);

const Td = ({ children, flex = 1 }) => (
  <Box flex={flex} p={2}>
    {children}
  </Box>
);

const MenuRow = ({ label, onPress }) => (
  <Pressable onPress={onPress} _pressed={{ opacity: 0.9 }}>
    <HStack alignItems="center" w="100%" mb={1.5}>
      <Box w="50px" alignItems="center" justifyContent="center">
        <Image
          alt="arrow"
          source={require("../../../assets/customerDataArrow.png")}
          width="28px"
          height="28px"
          resizeMode="contain"
        />
      </Box>
      <Box
        flex={1}
        bg="#F5E6BF"
        h="40px"
        borderRadius={0}
        justifyContent="center"
        px={3}
      >
        <Text
          color={GlobalStyles.colors.black}
          fontSize="md"
          fontFamily={GlobalStyles.text.fontFamily}
        >
          {label}
        </Text>
      </Box>
    </HStack>
  </Pressable>
);

const HeaderPill = ({ text, width = "100%", height = 40 }) => (
  <Box
    width={width}
    height={`${height}px`}
    bg="#FFC00091"
    borderRadius={0}
    alignItems="center"
    justifyContent="center"
  >
    <Text
      color={GlobalStyles.colors.blue}
      fontSize={["sm", "md", "lg"]}
      fontWeight="bold"
      fontFamily={GlobalStyles.text.fontFamily}
      textAlign="center"
    >
      {text}
    </Text>
  </Box>
);

const ActionButton = ({
  label,
  onPress,
  width = 100,
  height = 36,
  isLoading = false,
  isDisabled = false,
}) => (
  <Pressable
    onPress={onPress}
    _pressed={{ opacity: 0.9 }}
    disabled={isLoading || isDisabled}
  >
    <Box
      w={`${width}px`}
      h={`${height}px`}
      bg={GlobalStyles.colors.blue}
      borderRadius={0}
      alignItems="center"
      justifyContent="center"
      opacity={isDisabled ? 0.5 : 1}
    >
      {isLoading ? (
        <Spinner color={GlobalStyles.colors.mustard} size="sm" />
      ) : (
        <Text
          color={GlobalStyles.colors.mustard}
          fontWeight="bold"
          fontFamily={GlobalStyles.text.fontFamily}
        >
          {label}
        </Text>
      )}
    </Box>
  </Pressable>
);

const GroupRow = ({ label, checked, onToggle }) => (
  <Pressable onPress={onToggle} _pressed={{ opacity: 0.92 }}>
    <HStack alignItems="center" w="100%" mb={1.5}>
      <Box w="32px" alignItems="center">
        <CustomCheckbox checked={checked} />
      </Box>
      <Box
        flex={1}
        bg="#F5E6BF"
        h="38px"
        borderRadius={0}
        justifyContent="center"
        px={3}
      >
        <Text
          color={GlobalStyles.colors.black}
          fontSize="sm"
          fontFamily={GlobalStyles.text.fontFamily}
        >
          {label}
        </Text>
      </Box>
    </HStack>
  </Pressable>
);

const HomeButton = ({ onPress }) => (
  <Pressable onPress={onPress} alignSelf="flex-start">
    <HStack
      alignItems="center"
      space={2}
      bg="rgba(3, 0, 87, 0.1)"
      px={4}
      py={2}
      borderRadius={8}
    >
      <Icon
        as={Ionicons}
        name="home"
        size="md"
        color={GlobalStyles.colors.blue}
      />
      <Text
        fontSize="14px"
        fontWeight="400"
        color={GlobalStyles.colors.blue}
        fontFamily={GlobalStyles.text.fontFamily}
      >
        Home
      </Text>
    </HStack>
  </Pressable>
);

const ScreenNav = ({ onHome }) => (
  <HStack w="100%" justifyContent="flex-end" alignItems="center" px={3} mb={3} mt={2}>
    <HomeButton onPress={onHome} />
  </HStack>
);

const CampaignDetailModal = ({ isOpen, onClose, campaign }) => {
  if (!campaign) return null;

  return (
    <Modal
      visible={isOpen}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <Pressable
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          justifyContent: "center",
          alignItems: "center",
        }}
        onPress={onClose}
      >
        <Pressable
          style={{
            width: "90%",
            maxWidth: 600,
            backgroundColor: "white",
            borderRadius: 12,
            padding: 0,
            maxHeight: "80%",
          }}
          onPress={(e) => e.stopPropagation()}
        >
          <Box bg="#FFC00091" p={4} borderTopRadius={12}>
            <HStack justifyContent="space-between" alignItems="center">
              <Text fontWeight="bold" fontFamily={GlobalStyles.text.fontFamily}>
                Campaign Details
              </Text>
            </HStack>
          </Box>

          <ScrollView p={4}>
            <VStack space={2}>
              <Box>
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  mb={1}
                >
                  Subject:
                </Text>
                <Text fontFamily={GlobalStyles.text.fontFamily}>
                  {campaign.subject}
                </Text>
              </Box>
              <Box>
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  mb={1}
                >
                  Content:
                </Text>
                <Text fontFamily={GlobalStyles.text.fontFamily}>
                  {campaign.content || "No content"}
                </Text>
              </Box>
              <Box>
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  mb={1}
                >
                  Created:
                </Text>
                <Text fontFamily={GlobalStyles.text.fontFamily}>
                  {new Date(campaign.created_at).toLocaleString()}
                </Text>
              </Box>
              <Box>
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  mb={1}
                >
                  Status:
                </Text>
                <Text fontFamily={GlobalStyles.text.fontFamily}>
                  {campaign.status || "Active"}
                </Text>
              </Box>
            </VStack>
          </ScrollView>

          <HStack
            p={4}
            justifyContent="flex-end"
            borderTopWidth={1}
            borderColor="#E5E5E5"
          >
            <Button onPress={onClose} bg={GlobalStyles.colors.blue}>
              <Text
                color={GlobalStyles.colors.mustard}
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Close
              </Text>
            </Button>
          </HStack>
        </Pressable>
      </Pressable>
    </Modal>
  );
};

const EmailEditModal = ({ isOpen, onClose, email, onSave }) => {
  const [editedEmail, setEditedEmail] = useState(email?.email_address || "");
  const toast = useToast();

  useEffect(() => {
    if (email) {
      setEditedEmail(email.email_address);
    }
  }, [email]);

  const handleSave = () => {
    if (!editedEmail.trim()) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Email cannot be empty"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(editedEmail)) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Enter a valid email"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    onSave(editedEmail);
    onClose();
  };

  if (!email) return null;

  return (
    <Modal
      visible={isOpen}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <Pressable
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          justifyContent: "center",
          alignItems: "center",
        }}
        onPress={onClose}
      >
        <Pressable
          style={{
            width: "90%",
            maxWidth: 400,
            backgroundColor: "white",
            borderRadius: 12,
            padding: 0,
          }}
          onPress={(e) => e.stopPropagation()}
        >
          <Box bg="#FFC00091" p={4} borderTopRadius={12}>
            <HStack justifyContent="space-between" alignItems="center">
              <Text fontWeight="bold" fontFamily={GlobalStyles.text.fontFamily}>
                Edit Email
              </Text>
              <Pressable onPress={onClose}>
                <Text fontSize="xl" fontWeight="bold">
                  ×
                </Text>
              </Pressable>
            </HStack>
          </Box>

          <Box p={4}>
            <Input
              value={editedEmail}
              onChangeText={setEditedEmail}
              placeholder="Email Address"
              variant="outline"
              borderColor="#D1D5DB"
              _focus={{ borderColor: GlobalStyles.colors.blue }}
              fontFamily={GlobalStyles.text.fontFamily}
            />
          </Box>

          <HStack
            p={4}
            justifyContent="flex-end"
            space={2}
            borderTopWidth={1}
            borderColor="#E5E5E5"
          >
            <Button variant="ghost" onPress={onClose}>
              <Text fontFamily={GlobalStyles.text.fontFamily}>Cancel</Text>
            </Button>
            <Button onPress={handleSave} bg={GlobalStyles.colors.blue}>
              <Text
                color={GlobalStyles.colors.mustard}
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Save
              </Text>
            </Button>
          </HStack>
        </Pressable>
      </Pressable>
    </Modal>
  );
};
const MainMenu = ({
  onViewGroups,
  onAddDeleteGroup,
  onAddToGroup,
  onSendMessages,
  onMessagesHistory,
  onGroupStats,
}) => {
  const menuOptions = [
    { label: "View Current Customer Groups", action: onViewGroups },
    { label: "Add – Delete Customer Group", action: onAddDeleteGroup },
    { label: "Add new Customers", action: onAddToGroup },          
    { label: "Send new Message", action: onSendMessages },        
    { label: "Message History", action: onMessagesHistory },
    { label: "Group Stats", action: onGroupStats },
  ];

  return (
    <Center w="100%" bg={GlobalStyles.colors.lightGrey} py={5}>
      <VStack
        w="100%"
        maxW={["90%", "90%", "700px"]}
        alignItems="center"
        space={3}
      >
        <Box w={["250px", "280px", "300px"]}>
          <HeaderPill text="Customer Data Management" />
        </Box>

        <VStack w="100%" px={3} space={1.5}>
          {menuOptions.map((option, index) => (
            <MenuRow key={index} label={option.label} onPress={option.action} />
          ))}
        </VStack>
      </VStack>
    </Center>
  );
};

const ViewGroups = ({ groups, onDone, onBack, isLoading, onToggleGroup, onHome }) => {
  return (
    <Center bg={GlobalStyles.colors.lightGrey} py={4}>
      <Box w={["92%", "90%", "640px"]}>
        <ScreenNav onHome={onHome} />
        <Box bg={GlobalStyles.colors.white} borderRadius={24} p={5} shadow={3}>
          <Text
            color={GlobalStyles.colors.black}
            fontSize="sm"
            mb={3}
            fontFamily={GlobalStyles.text.fontFamily}
            textAlign="center"
          >
            Customer Data Management
          </Text>

          <HStack w="100%" justifyContent="center" mb={4}>
            <Box
              width={["200px", "250px", "300px"]}
              height="32px"
              bg="#FFC00091"
              borderRadius={0}
              alignItems="center"
              justifyContent="center"
            >
              <Text
                color={GlobalStyles.colors.blue}
                fontWeight="bold"
                fontSize="sm"
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Current Customer Groups
              </Text>
            </Box>
          </HStack>

          {isLoading ? (
            <Center py={8}>
              <Spinner size="lg" color={GlobalStyles.colors.blue} />
            </Center>
          ) : groups.length === 0 ? (
            <Center py={8}>
              <Text fontFamily={GlobalStyles.text.fontFamily}>
                No groups found
              </Text>
            </Center>
          ) : (
            <ScrollView maxH="350px">
              <VStack space={1.5} mb={4}>
                {groups.map((group) => (
                  <GroupRow
                    key={group.id}
                    label={group.name}
                    checked={group.checked}
                    onToggle={() => onToggleGroup(group.id)}
                  />
                ))}
              </VStack>
            </ScrollView>
          )}

          <HStack w="100%" justifyContent="center" space={3} mt={3}>
            <ActionButton label="Back" onPress={onBack} />
            <ActionButton label="Done" onPress={onDone} isLoading={isLoading} />
          </HStack>
        </Box>
      </Box>
    </Center>
  );
};

const AddDeleteGroup = ({ groups, onDone, onBack, isLoading, onToggleGroup, onHome }) => {
  const [groupName, setGroupName] = useState("");

  const handleSubmit = () => {
    onDone({ name: groupName.trim(), groups });
    setGroupName("");
  };

  return (
    <Center bg={GlobalStyles.colors.lightGrey} py={4}>
      <Box w={["92%", "90%", "640px"]}>
        <ScreenNav onHome={onHome} />
        <Box
          bg={GlobalStyles.colors.white}
          borderRadius={16}
          p={4}
          shadow={3}
          mb={3}
        >
          <HStack w="100%" justifyContent="center" mb={2}>
            <Box
              width={["200px", "250px", "300px"]}
              height="30px"
              bg="#FFC00091"
              borderRadius={0}
              alignItems="center"
              justifyContent="center"
            >
              <Text
                color={GlobalStyles.colors.blue}
                fontWeight="bold"
                fontSize="sm"
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Add New Customer Group
              </Text>
            </Box>
          </HStack>

          <Input
            value={groupName}
            onChangeText={setGroupName}
            placeholder="Name"
            variant="outline"
            borderColor="#D1D5DB"
            _focus={{ borderColor: GlobalStyles.colors.blue }}
            fontFamily={GlobalStyles.text.fontFamily}
            isDisabled={isLoading}
          />
        </Box>

        <Box bg={GlobalStyles.colors.white} borderRadius={16} p={4} shadow={3}>
          <HStack w="100%" justifyContent="center" mb={2}>
            <Box
              width={["200px", "250px", "300px"]}
              height="30px"
              bg="#FFC00091"
              borderRadius={0}
              alignItems="center"
              justifyContent="center"
            >
              <Text
                color={GlobalStyles.colors.blue}
                fontWeight="bold"
                fontSize="sm"
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Delete Customer Group
              </Text>
            </Box>
          </HStack>

          {isLoading ? (
            <Center py={8}>
              <Spinner size="lg" color={GlobalStyles.colors.blue} />
            </Center>
          ) : groups.length === 0 ? (
            <Center py={8}>
              <Text fontFamily={GlobalStyles.text.fontFamily}>
                No groups found
              </Text>
            </Center>
          ) : (
            <ScrollView maxH="250px">
              <VStack space={1.5} mb={3}>
                {groups.map((group) => (
                  <Pressable
                    key={group.id}
                    onPress={() => onToggleGroup(group.id)}
                    _pressed={{ opacity: 0.95 }}
                  >
                    <HStack alignItems="center">
                      <Box w="24px" alignItems="center">
                        <CustomCheckbox
                          checked={group.checked}
                          color={GlobalStyles.colors.blue}
                        />
                      </Box>
                      <Box
                        flex={1}
                        bg="#F5E6BF"
                        h="30px"
                        borderRadius={0}
                        justifyContent="center"
                        px={3}
                      >
                        <Text
                          color={GlobalStyles.colors.black}
                          fontSize="sm"
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          {group.name}
                        </Text>
                      </Box>
                    </HStack>
                  </Pressable>
                ))}
              </VStack>
            </ScrollView>
          )}

          <HStack w="100%" justifyContent="center" space={3}>
            <ActionButton label="Back" onPress={onBack} />
            <ActionButton
              label="Done"
              onPress={handleSubmit}
              isLoading={isLoading}
            />
          </HStack>
        </Box>
      </Box>
    </Center>
  );
};

const SelectEmailSource = ({ onNext, onBack, onHome }) => {
  const [useCsv, setUseCsv] = useState(true);
  const [useSingle, setUseSingle] = useState(true);

  return (
    <Center bg={GlobalStyles.colors.lightGrey} py={8}>
      <Box w={["92%", "90%", "640px"]}>
        <ScreenNav onHome={onHome} />
        <Box
          bg={GlobalStyles.colors.white}
          borderTopRadius={24}
          borderBottomRadius={0}
          px={5}
          pt={5}
          pb={6}
        >
          <HStack w="100%" justifyContent="center" mb={4}>
            <Text
              color={GlobalStyles.colors.blue}
              fontWeight="bold"
              fontSize="md"
              fontFamily={GlobalStyles.text.fontFamily}
              textAlign="center"
            >
              Add Customer (Email) to Customer Group
            </Text>
          </HStack>

          <Text
            color={GlobalStyles.colors.black}
            fontSize="md"
            mb={3}
            fontFamily={GlobalStyles.text.fontFamily}
          >
            Select Your Email Source
          </Text>

          <VStack space={2.5} mb={5}>
            <Pressable
              onPress={() => setUseCsv((v) => !v)}
              _pressed={{ opacity: 0.95 }}
            >
              <HStack alignItems="center">
                <Box w="28px" alignItems="center">
                  <CustomCheckbox
                    size={22}
                    checked={useCsv}
                    color={GlobalStyles.colors.blue}
                  />
                </Box>
                <Box
                  flex={1}
                  bg="#F5E6BF"
                  h="36px"
                  borderRadius={0}
                  justifyContent="center"
                  px={3}
                >
                  <Text
                    color={GlobalStyles.colors.black}
                    fontFamily={GlobalStyles.text.fontFamily}
                  >
                    CSV
                  </Text>
                </Box>
              </HStack>
            </Pressable>

            <Pressable
              onPress={() => setUseSingle((v) => !v)}
              _pressed={{ opacity: 0.95 }}
            >
              <HStack alignItems="center">
                <Box w="28px" alignItems="center">
                  <CustomCheckbox
                    size={22}
                    checked={useSingle}
                    color={GlobalStyles.colors.blue}
                  />
                </Box>
                <Box
                  flex={1}
                  bg="#F5E6BF"
                  h="36px"
                  borderRadius={0}
                  justifyContent="center"
                  px={3}
                >
                  <Text
                    color={GlobalStyles.colors.black}
                    fontFamily={GlobalStyles.text.fontFamily}
                  >
                    Add a single manual email
                  </Text>
                </Box>
              </HStack>
            </Pressable>
          </VStack>

          <HStack w="100%" justifyContent="center" space={3}>
            <ActionButton label="Back" onPress={onBack} />
            <Pressable
              onPress={() => onNext({ csv: useCsv, single: useSingle })}
              _pressed={{ opacity: 0.9 }}
            >
              <Box
                w="120px"
                h="36px"
                bg={GlobalStyles.colors.blue}
                borderRadius={0}
                alignItems="center"
                justifyContent="center"
              >
                <Text
                  color={GlobalStyles.colors.mustard}
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                >
                  Next
                </Text>
              </Box>
            </Pressable>
          </HStack>
        </Box>
      </Box>
    </Center>
  );
};

const UploadCsv = ({
  groups,
  onDone,
  onBack,
  isLoading,
  onToggleGroup,
  onUploadCSV,
  onHome,
}) => {
  const [fileName, setFileName] = useState("");
  const toast = useToast();

  const handleUpload = async () => {
    try {
      const result = await DocumentPicker.getDocumentAsync({
        type: "text/csv",
        copyToCacheDirectory: true,
      });

      if (result.type === "success" || result.assets) {
        const file = result.assets ? result.assets[0] : result;
        setFileName(file.name);
        onUploadCSV(file);
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Error in selecting file"
          />
        ),
        placement: "top",
        duration: 2000,
      });
    }
  };

  return (
    <Center bg={GlobalStyles.colors.lightGrey} py={4}>
      <Box w={["92%", "90%", "640px"]}>
        <ScreenNav onHome={onHome} />
        <Box
          bg={GlobalStyles.colors.white}
          borderRadius={18}
          p={4}
          shadow={3}
          mb={3}
        >
          <HStack w="100%" justifyContent="center" mb={3}>
            <Box
              width={["150px", "180px", "200px"]}
              height="32px"
              bg="#FFC00091"
              borderRadius={0}
              alignItems="center"
              justifyContent="center"
            >
              <Text
                color={GlobalStyles.colors.blue}
                fontWeight="bold"
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Upload CSV
              </Text>
            </Box>
          </HStack>

          <HStack
            w="100%"
            alignItems="center"
            flexWrap="wrap"
            justifyContent="space-between"
          >
            <Pressable onPress={handleUpload} _pressed={{ opacity: 0.9 }}>
              <Box
                w="110px"
                h="34px"
                bg={GlobalStyles.colors.blue}
                borderRadius={0}
                alignItems="center"
                justifyContent="center"
              >
                <Text
                  color={GlobalStyles.colors.mustard}
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                >
                  Upload
                </Text>
              </Box>
            </Pressable>
            <Box flex={1} minW="8px" />
            <Box
              w={["140px", "160px", "176px"]}
              h="34px"
              bg="#F4F1EA"
              borderRadius={8}
              alignItems="center"
              justifyContent="center"
            >
              <Text
                color="#6B6B6B"
                fontFamily={GlobalStyles.text.fontFamily}
                numberOfLines={1}
              >
                {fileName || ".."}
              </Text>
            </Box>
          </HStack>
        </Box>

        <Box bg={GlobalStyles.colors.white} borderRadius={18} p={4} shadow={3}>
          <HStack w="100%" justifyContent="center" mb={2}>
            <Box
              width={["150px", "165px", "180px"]}
              height="32px"
              bg="#FFC00091"
              borderRadius={0}
              alignItems="center"
              justifyContent="center"
            >
              <Text
                color={GlobalStyles.colors.blue}
                fontWeight="bold"
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Select Group
              </Text>
            </Box>
          </HStack>

          {isLoading ? (
            <Center py={8}>
              <Spinner size="lg" color={GlobalStyles.colors.blue} />{" "}
            </Center>
          ) : groups.length === 0 ? (
            <Center py={8}>
              <Text fontFamily={GlobalStyles.text.fontFamily}>
                No groups found
              </Text>
            </Center>
          ) : (
            <ScrollView maxH="180px">
              <VStack space={1.5} mb={3}>
                {groups.map((group) => (
                  <Pressable
                    key={group.id}
                    onPress={() => onToggleGroup(group.id)}
                    _pressed={{ opacity: 0.95 }}
                  >
                    <HStack alignItems="center">
                      <Box w="26px" alignItems="center">
                        <CustomCheckbox
                          checked={group.checked}
                          color={GlobalStyles.colors.blue}
                        />
                      </Box>
                      <Box
                        flex={1}
                        bg="#F5E6BF"
                        h="32px"
                        borderRadius={0}
                        justifyContent="center"
                        px={3}
                      >
                        <Text
                          color={GlobalStyles.colors.black}
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          {group.name}
                        </Text>
                      </Box>
                    </HStack>
                  </Pressable>
                ))}
              </VStack>
            </ScrollView>
          )}

          <HStack w="100%" justifyContent="center" space={3}>
            <ActionButton label="Back" onPress={onBack} />
            <ActionButton label="Done" onPress={onDone} isLoading={isLoading} />
          </HStack>
        </Box>
      </Box>
    </Center>
  );
};

const AddSingleEmail = ({ onNext, onBack, groups, isLoading, onToggleGroup, onHome }) => {
  const [email, setEmail] = useState("");
  const toast = useToast();

  const handleSubmit = () => {
    if (!email.trim()) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Enter an email address"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Enter a valid email address"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    onNext({ email, groups });
  };

  return (
    <Center bg={GlobalStyles.colors.lightGrey} py={4}>
      <Box w={["92%", "90%", "640px"]}>
        <ScreenNav onHome={onHome} />
        <Box
          bg={GlobalStyles.colors.white}
          borderRadius={12}
          p={4}
          mb={3}
          shadow={3}
        >
          <HStack w="100%" justifyContent="center" mb={3}>
            <Box
              width={["220px", "250px", "280px"]}
              height="36px"
              bg="#FFC00091"
              borderRadius={0}
              alignItems="center"
              justifyContent="center"
            >
              <Text
                color={GlobalStyles.colors.blue}
                fontSize="md"
                fontWeight="bold"
                fontFamily={GlobalStyles.text.fontFamily}
                textAlign="center"
              >
                Add a single manual email
              </Text>
            </Box>
          </HStack>

          <Input
            value={email}
            onChangeText={setEmail}
            placeholder="Enter Email:"
            variant="outline"
            borderColor="#D1D5DB"
            _focus={{ borderColor: GlobalStyles.colors.blue }}
            h="38px"
            bg={GlobalStyles.colors.white}
            fontFamily={GlobalStyles.text.fontFamily}
            isDisabled={isLoading}
          />
        </Box>

        <Box bg={GlobalStyles.colors.white} borderRadius={12} p={4} shadow={3}>
          <HStack w="100%" justifyContent="center" mb={3}>
            <Box
              width={["150px", "165px", "180px"]}
              height="36px"
              bg="#FFC00091"
              borderRadius={0}
              alignItems="center"
              justifyContent="center"
            >
              <Text
                color={GlobalStyles.colors.blue}
                fontSize="md"
                fontWeight="bold"
                fontFamily={GlobalStyles.text.fontFamily}
              >
                Select Group
              </Text>
            </Box>
          </HStack>

          {isLoading ? (
            <Center py={8}>
              <Spinner size="lg" color={GlobalStyles.colors.blue} />
            </Center>
          ) : (
            <ScrollView maxH="220px">
              <VStack space={1.5} mb={4}>
                {groups.map((group) => (
                  <GroupRow
                    key={group.id}
                    label={group.name}
                    checked={group.checked}
                    onToggle={() => onToggleGroup(group.id)}
                  />
                ))}
              </VStack>
            </ScrollView>
          )}

          <HStack w="100%" justifyContent="center" space={3}>
            <ActionButton label="Back" onPress={onBack} />
            <ActionButton
              label="Add to Group"
              width={130}
              onPress={handleSubmit}
              isLoading={isLoading}
            />
          </HStack>
        </Box>
      </Box>
    </Center>
  );
};

const ComposeEmail = ({ onBack, onGoBack, groups, isLoading, onToggleGroup, onHome }) => {
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [recipientType, setRecipientType] = useState("group"); 
  const [singleEmail, setSingleEmail] = useState("");
  const toast = useToast();

  const handleInsertImage = async () => {
    try {
      setImageLoading(true);

      const { status } =
        await ImagePicker.requestMediaLibraryPermissionsAsync();

      if (status !== "granted") {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message="Permission to access gallery is required"
            />
          ),
          placement: "top",
          duration: 2000,
        });
        setImageLoading(false);
        return;
      }

      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [4, 3],
        quality: 0.8,
        base64: false,
      });

      if (!result.canceled && result.assets && result.assets.length > 0) {
        setSelectedImage(result.assets[0].uri);
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.mustard}
              message="Image selected successfully!"
            />
          ),
          placement: "top",
          duration: 2000,
        });
      } else if (!result.canceled && result.uri) {
        setSelectedImage(result.uri);
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.mustard}
              message="Image selected successfully!"
            />
          ),
          placement: "top",
          duration: 2000,
        });
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Error selecting image"
          />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setImageLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!subject.trim()) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Enter a subject"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    if (recipientType === "group") {
      const selectedGroups = groups.filter((g) => g.checked);
      if (selectedGroups.length === 0) {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message="Select at least one group"
            />
          ),
          placement: "top",
          duration: 2000,
        });
        return;
      }
      onBack({ subject, content, selectedGroups, image: selectedImage });
    } else {
      if (!singleEmail.trim()) {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message="Please enter a recipient email"
            />
          ),
          placement: "top",
          duration: 2000,
        });
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(singleEmail)) {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message="Please enter a valid email address"
            />
          ),
          placement: "top",
          duration: 2000,
        });
        return;
      }
      onBack({ subject, content, singleEmail, image: selectedImage });
    }
  };

  return (
    <ScrollView bg={GlobalStyles.colors.lightGrey}>
      <Center py={4}>
        <Box w={["92%", "90%", "640px"]}>
          <ScreenNav onHome={onHome} />

          <Box
            bg={GlobalStyles.colors.white}
            borderRadius={12}
            p={4}
            mb={3}
            shadow={3}
          >
            <HStack w="100%" justifyContent="center" mb={3}>
              <Box
                width={["150px", "175px", "200px"]}
                height="36px"
                bg="#FFC00091"
                borderRadius={0}
                alignItems="center"
                justifyContent="center"
              >
                <Text
                  color={GlobalStyles.colors.blue}
                  fontSize="md"
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                >
                  Compose Email
                </Text>
              </Box>
            </HStack>

            <Text
              fontSize="sm"
              fontFamily={GlobalStyles.text.fontFamily}
              mb={1.5}
            >
              Subject:
            </Text>
            <Input
              value={subject}
              onChangeText={setSubject}
              placeholder=""
              variant="outline"
              borderColor="#D1D5DB"
              _focus={{ borderColor: GlobalStyles.colors.blue }}
              mb={2}
              h="46px"
              bg={GlobalStyles.colors.white}
              fontFamily={GlobalStyles.text.fontFamily}
              isDisabled={isLoading}
            />

            <Text
              fontSize="sm"
              fontFamily={GlobalStyles.text.fontFamily}
              mb={1.5}
            >
              Content:
            </Text>
            <TextArea
              value={content}
              onChangeText={setContent}
              placeholder="Write your email content here.."
              variant="outline"
              borderColor="#D1D5DB"
              _focus={{ borderColor: GlobalStyles.colors.blue }}
              mb={2}
              h="140px"
              bg={GlobalStyles.colors.white}
              fontFamily={GlobalStyles.text.fontFamily}
              isDisabled={isLoading}
            />

            {selectedImage && (
              <Box
                mb={2}
                alignItems="center"
                bg="#FFC0000D"
                p={2}
                borderRadius={8}
              >
                <Image
                  source={{ uri: selectedImage }}
                  alt="Selected"
                  width="200px"
                  height="150px"
                  borderRadius={8}
                  resizeMode="cover"
                />
                <Pressable onPress={() => setSelectedImage(null)} mt={1.5}>
                  <Text
                    color={GlobalStyles.colors.red}
                    fontSize="sm"
                    fontWeight="bold"
                    fontFamily={GlobalStyles.text.fontFamily}
                  >
                    Remove Image
                  </Text>
                </Pressable>
              </Box>
            )}

            <HStack w="100%" justifyContent="center">
              <ActionButton
                label={imageLoading ? "Loading..." : "Insert Image"}
                onPress={handleInsertImage}
                width={130}
                isLoading={imageLoading}
                isDisabled={isLoading || imageLoading}
              />
            </HStack>
          </Box>

          <Box
            bg={GlobalStyles.colors.white}
            borderRadius={12}
            p={4}
            shadow={3}
          >
            <Text
              fontSize="md"
              fontWeight="500"
              fontFamily={GlobalStyles.text.fontFamily}
              mb={3}
            >
              Add Recipients
            </Text>

            <HStack space={3} mb={4}>
              <Pressable
                onPress={() => setRecipientType("group")}
                _pressed={{ opacity: 0.9 }}
              >
                <HStack alignItems="center" space={2}>
                  <CustomCheckbox
                    size={20}
                    checked={recipientType === "group"}
                    color={GlobalStyles.colors.blue}
                  />
                  <Text
                    fontFamily={GlobalStyles.text.fontFamily}
                    color={GlobalStyles.colors.black}
                  >
                    Group
                  </Text>
                </HStack>
              </Pressable>

              <Pressable
                onPress={() => setRecipientType("single")}
                _pressed={{ opacity: 0.9 }}
              >
                <HStack alignItems="center" space={2}>
                  <CustomCheckbox
                    size={20}
                    checked={recipientType === "single"}
                    color={GlobalStyles.colors.blue}
                  />
                  <Text
                    fontFamily={GlobalStyles.text.fontFamily}
                    color={GlobalStyles.colors.black}
                  >
                    Single Recipient
                  </Text>
                </HStack>
              </Pressable>
            </HStack>

            {recipientType === "group" ? (
              <>
                <HStack w="100%" justifyContent="center" mb={3}>
                  <Box
                    width={["150px", "165px", "180px"]}
                    height="36px"
                    bg="#FFC00091"
                    borderRadius={0}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text
                      color={GlobalStyles.colors.blue}
                      fontSize="md"
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                    >
                      Select Group
                    </Text>
                  </Box>
                </HStack>

                {isLoading ? (
                  <Center py={8}>
                    <Spinner size="lg" color={GlobalStyles.colors.blue} />
                  </Center>
                ) : (
                  <ScrollView maxH="180px">
                    <VStack space={1.5} mb={4}>
                      {groups.map((group) => (
                        <GroupRow
                          key={group.id}
                          label={group.name}
                          checked={group.checked}
                          onToggle={() => onToggleGroup(group.id)}
                        />
                      ))}
                    </VStack>
                  </ScrollView>
                )}
              </>
            ) : (
              <Box mb={4}>
                <Text
                  fontSize="sm"
                  fontFamily={GlobalStyles.text.fontFamily}
                  mb={1.5}
                >
                  Recipient Email:
                </Text>
                <Input
                  value={singleEmail}
                  onChangeText={setSingleEmail}
                  placeholder="Enter recipient email"
                  variant="outline"
                  borderColor="#D1D5DB"
                  _focus={{ borderColor: GlobalStyles.colors.blue }}
                  h="42px"
                  bg={GlobalStyles.colors.white}
                  fontFamily={GlobalStyles.text.fontFamily}
                  isDisabled={isLoading}
                  keyboardType="email-address"
                  autoCapitalize="none"
                />
              </Box>
            )}

            <HStack w="100%" justifyContent="center" space={3}>
              <ActionButton label="Back" onPress={onGoBack} />
              <ActionButton
                label="Done"
                onPress={handleSubmit}
                isLoading={isLoading}
              />
            </HStack>
          </Box>
        </Box>
      </Center>
    </ScrollView>
  );
};

const MessagesHistory = ({
  onBack,
  campaigns,
  isLoading,
  onDeleteCampaign,
  onHome,
}) => {
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleViewCampaign = (campaign) => {
    setSelectedCampaign(campaign);
    setShowModal(true);
  };

  return (
    <>
      <Center bg={GlobalStyles.colors.lightGrey} py={4}>
        <Box w={["92%", "90%", "640px"]}>
          <ScreenNav onHome={onHome} />
          <HStack w="100%" justifyContent="center" mb={4}>
            <Box width={["180px", "200px", "220px"]}>
              <HeaderPill text="Message History" height={36} />
            </Box>
          </HStack>

          {isLoading ? (
            <Center py={16}>
              <Spinner size="lg" color={GlobalStyles.colors.blue} />
            </Center>
          ) : campaigns.length === 0 ? (
            <Center py={16}>
              <Text fontFamily={GlobalStyles.text.fontFamily}>
                No campaigns found
              </Text>
            </Center>
          ) : (
            <ScrollView>
              <Table>
                <Thead bg={GlobalStyles.colors.mustard}>
                  <Tr>
                    <Th flex={2}>
                      <Text
                        color={GlobalStyles.colors.black}
                        fontWeight="bold"
                        fontSize="sm"
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Date
                      </Text>
                    </Th>
                    <Th flex={3}>
                      <Text
                        color={GlobalStyles.colors.black}
                        fontWeight="bold"
                        fontSize="sm"
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Subject
                      </Text>
                    </Th>
                    <Th flex={1}>
                      <Box />
                    </Th>
                    <Th flex={1}>
                      <Box />
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {campaigns.map((msg, index) => (
                    <Tr
                      key={msg.id}
                      bg={
                        index % 2 === 0 ? GlobalStyles.colors.white : "#FAFAFA"
                      }
                      isLast={index === campaigns.length - 1}
                    >
                      <Td flex={2}>
                        <Text
                          fontSize="sm"
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          {new Date(msg.created_at).toLocaleDateString()}
                        </Text>
                      </Td>
                      <Td flex={3}>
                        <Text
                          fontSize="sm"
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          {msg.subject}
                        </Text>
                      </Td>
                      <Td flex={1}>
                        <Pressable onPress={() => handleViewCampaign(msg)}>
                          <Text
                            color={GlobalStyles.colors.blue}
                            fontSize="sm"
                            fontFamily={GlobalStyles.text.fontFamily}
                            fontWeight="bold"
                            underline
                          >
                            Open
                          </Text>
                        </Pressable>
                      </Td>
                      <Td flex={1}>
                        <Pressable onPress={() => onDeleteCampaign(msg.id)}>
                          <Text
                            color={GlobalStyles.colors.red}
                            fontSize="sm"
                            fontFamily={GlobalStyles.text.fontFamily}
                            fontWeight="bold"
                            underline
                          >
                            Delete
                          </Text>
                        </Pressable>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </ScrollView>
          )}

          <HStack w="100%" justifyContent="center" mt={4}>
            <ActionButton label="Back" onPress={onBack} />
          </HStack>
        </Box>
      </Center>

      <CampaignDetailModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        campaign={selectedCampaign}
      />
    </>
  );
};

const GroupStats = ({ onBack, onViewDetails, groups, isLoading, onHome }) => {
  return (
    <Center bg={GlobalStyles.colors.lightGrey} py={4}>
      <Box w={["92%", "90%", "640px"]}>
        <ScreenNav onHome={onHome} />
        <HStack w="100%" justifyContent="center" mb={4}>
          <Box width={["220px", "240px", "260px"]}>
            <HeaderPill text="Customer Group Stats" height={36} />
          </Box>
        </HStack>

        {isLoading ? (
          <Center py={16}>
            <Spinner size="lg" color={GlobalStyles.colors.blue} />
          </Center>
        ) : groups.length === 0 ? (
          <Center py={16}>
            <Text fontFamily={GlobalStyles.text.fontFamily}>
              No groups found
            </Text>
          </Center>
        ) : (
          <ScrollView>
            <Table>
              <Thead bg={GlobalStyles.colors.mustard}>
                <Tr>
                  <Th flex={3}>
                    <Text
                      color={GlobalStyles.colors.black}
                      fontWeight="bold"
                      fontSize="sm"
                      fontFamily={GlobalStyles.text.fontFamily}
                    >
                      Group
                    </Text>
                  </Th>
                  <Th flex={2}>
                    <Text
                      color={GlobalStyles.colors.black}
                      fontWeight="bold"
                      fontSize="sm"
                      fontFamily={GlobalStyles.text.fontFamily}
                    >
                      Customer No.
                    </Text>
                  </Th>
                  <Th flex={1}>
                    <Box />
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {groups.map((group, index) => (
                  <Tr
                    key={group.id}
                    bg={index % 2 === 0 ? GlobalStyles.colors.white : "#FAFAFA"}
                    isLast={index === groups.length - 1}
                  >
                    <Td flex={3}>
                      <Text
                        fontSize="sm"
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {group.name}
                      </Text>
                    </Td>
                    <Td flex={2}>
                      <Text
                        fontSize="sm"
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {group.total_emails?.toLocaleString() || 0}
                      </Text>
                    </Td>
                    <Td flex={1}>
                      <Pressable onPress={() => onViewDetails(group)}>
                        <Text
                          color={GlobalStyles.colors.blue}
                          fontSize="sm"
                          fontFamily={GlobalStyles.text.fontFamily}
                          fontWeight="bold"
                          underline
                        >
                          Details
                        </Text>
                      </Pressable>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </ScrollView>
        )}

        <HStack w="100%" justifyContent="center" mt={4}>
          <ActionButton label="Back" onPress={onBack} />
        </HStack>
      </Box>
    </Center>
  );
};
const GroupEmailDetails = ({
  selectedGroup,
  onBack,
  emails,
  isLoading,
  onRemoveEmail,
  onEditEmail,
  onHome,
}) => {
  const [editingEmail, setEditingEmail] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const toast = useToast();

  const handleEdit = (email) => {
    setEditingEmail(email);
    setShowEditModal(true);
  };

  const handleSaveEdit = async (newEmailAddress) => {
    toast.show({
      render: () => (
        <Toast
          color={GlobalStyles.colors.mustard}
          message="Email updated successfully!"
        />
      ),
      placement: "top",
      duration: 2000,
    });
    setShowEditModal(false);

    if (onEditEmail) {
      onEditEmail(editingEmail.id, newEmailAddress);
    }
  };

  return (
    <>
      <Center bg={GlobalStyles.colors.lightGrey} py={4}>
        <Box w={["92%", "90%", "640px"]}>
          <ScreenNav onHome={onHome} />
          <HStack w="100%" justifyContent="center" mb={4}>
            <Box width={["230px", "255px", "280px"]}>
              <HeaderPill text="Customer Group Details" height={36} />
            </Box>
          </HStack>

          <Text fontSize="md" fontFamily={GlobalStyles.text.fontFamily} mb={2}>
            {selectedGroup?.name || "Group Details"}
          </Text>

          {isLoading ? (
            <Center py={16}>
              <Spinner size="lg" color={GlobalStyles.colors.blue} />
            </Center>
          ) : emails.length === 0 ? (
            <Center py={16}>
              <Text fontFamily={GlobalStyles.text.fontFamily}>
                No emails found in this group
              </Text>
            </Center>
          ) : (
            <ScrollView>
              <Table>
                <Thead bg={GlobalStyles.colors.mustard}>
                  <Tr>
                    <Th flex={3}>
                      <Text
                        color={GlobalStyles.colors.black}
                        fontWeight="bold"
                        fontSize="sm"
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Customer ID
                      </Text>
                    </Th>
                    <Th flex={2}>
                      <Text
                        color={GlobalStyles.colors.black}
                        fontWeight="bold"
                        fontSize="sm"
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Date
                      </Text>
                    </Th>
                    <Th flex={1}>
                      <Box />
                    </Th>
                    <Th flex={1}>
                      <Box />
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {emails.map((customer, index) => (
                    <Tr
                      key={customer.id}
                      bg={
                        index % 2 === 0 ? GlobalStyles.colors.white : "#FAFAFA"
                      }
                      isLast={index === emails.length - 1}
                    >
                      <Td flex={3}>
                        <Text
                          fontSize="sm"
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          {customer.email_address}
                        </Text>
                      </Td>
                      <Td flex={2}>
                        <Text
                          fontSize="sm"
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          {new Date(customer.created_at).toLocaleDateString()}
                        </Text>
                      </Td>
                      <Td flex={1}>
                        <Pressable onPress={() => handleEdit(customer)}>
                          <Text
                            color={GlobalStyles.colors.blue}
                            fontSize="sm"
                            fontFamily={GlobalStyles.text.fontFamily}
                            fontWeight="bold"
                            underline
                          >
                            Edit
                          </Text>
                        </Pressable>
                      </Td>
                      <Td flex={1}>
                        <Pressable onPress={() => onRemoveEmail(customer.id)}>
                          <Text
                            color={GlobalStyles.colors.red}
                            fontSize="sm"
                            fontFamily={GlobalStyles.text.fontFamily}
                            fontWeight="bold"
                            underline
                          >
                            Remove
                          </Text>
                        </Pressable>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </ScrollView>
          )}

          <HStack w="100%" justifyContent="center" mt={4}>
            <ActionButton label="Back" onPress={onBack} />
          </HStack>
        </Box>
      </Center>

      <EmailEditModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        email={editingEmail}
        onSave={handleSaveEdit}
      />
    </>
  );
};

const VIEWS = {
  MENU: "menu",
  GROUPS: "groups",
  ADD_DELETE: "add_delete",
  ADD_TO_GROUP: "add_to_group",
  ADD_EMAIL_CSV: "add_email_csv",
  SEND_MESSAGES_STEP1: "send_messages_step1",
  SEND_MESSAGES_STEP2: "send_messages_step2",
  MESSAGES_HISTORY: "messages_history",
  GROUP_STATS: "group_stats",
  GROUP_EMAIL: "group_email",
};

const CustomerData = ({ onBack }) => {
  const user = useSelector((state) => state.user.user);
  const toast = useToast();

  const [view, setView] = useState(VIEWS.MENU);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const scrollRef = useRef(null);
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [groupsLoading, setGroupsLoading] = useState(false);
  const [emailsLoading, setEmailsLoading] = useState(false);
  const [campaignsLoading, setCampaignsLoading] = useState(false);

  const [emailGroups, setEmailGroups] = useState([]);
  const [groupEmails, setGroupEmails] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [csvFile, setCsvFile] = useState(null);

  useEffect(() => {
    if (user?.token) {
      axios.defaults.headers.common = {
        Authorization: `bearer ${user.token}`,
      };
    }
  }, [user]);

  const fetchEmailGroups = useCallback(async () => {
    setGroupsLoading(true);
    try {
      const response = await axios.get(`${EMAIL_API_BASE_URL}/email-groups`, {
        timeout: 10000,
      });

      if (response.data?.message === "Email groups retrieved successfully") {
        const groups = response.data.groups.map((g) => ({
          id: g.id,
          name: g.name,
          description: g.description,
          total_emails: g.total_emails,
          status: g.status,
          checked: false,
        }));
        setEmailGroups(groups);
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={
              error.response?.data?.message || "Error fetching email groups"
            }
          />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setGroupsLoading(false);
    }
  }, [toast]);

  const fetchGroupEmails = useCallback(
    async (groupId) => {
      setEmailsLoading(true);
      try {
        const response = await axios.get(
          `${EMAIL_API_BASE_URL}/email-groups/${groupId}`,
          {
            timeout: 10000,
          },
        );

        if (response.data?.message === "Email group retrieved successfully") {
          setGroupEmails(response.data.group.emails || []);
          setSelectedGroup(response.data.group);
        }
      } catch (error) {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message={
                error.response?.data?.message || "Error fetching group emails"
              }
            />
          ),
          placement: "top",
          duration: 2000,
        });
      } finally {
        setEmailsLoading(false);
      }
    },
    [toast],
  );

  const fetchCampaigns = useCallback(async () => {
    setCampaignsLoading(true);
    try {
      const response = await axios.get(`${EMAIL_API_BASE_URL}/campaigns`, {
        timeout: 10000,
      });

      if (response.data?.message === "Campaigns retrieved successfully") {
        setCampaigns(response.data.campaigns || []);
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={
              error.response?.data?.message || "Error fetching campaigns"
            }
          />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setCampaignsLoading(false);
    }
  }, [toast]);

  const toggleGroupSelection = useCallback((id) => {
    setEmailGroups((prev) =>
      prev.map((g) => (g.id === id ? { ...g, checked: !g.checked } : g)),
    );
  }, []);

  const addSingleEmail = async (data) => {
    if (!data.email) return;

    setIsLoading(true);
    try {
      const emailResponse = await axios.post(
        `${EMAIL_API_BASE_URL}/emails`,
        {
          email_address: data.email,
        },
        {
          timeout: 10000,
        },
      );

      if (emailResponse.data?.message === "Email added successfully") {
        const emailId = emailResponse.data.email.id;

        const selectedGroups = data.groups.filter((g) => g.checked);

        await Promise.all(
          selectedGroups.map((group) =>
            axios
              .post(
                `${EMAIL_API_BASE_URL}/email-groups/${group.id}/emails/${emailId}`,
                {},
                {
                  timeout: 10000,
                },
              )
              .catch((error) => {
                console.log(`Error adding to group ${group.id}:`, error);
              }),
          ),
        );

        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message="Email added successfully!"
            />
          ),
          placement: "top",
          duration: 2000,
        });

        setView(VIEWS.MENU);
        await fetchEmailGroups();
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={error.response?.data?.message || "Error adding email"}
          />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCSVUpload = (file) => {
    setCsvFile(file);
  };

  const processCSVUpload = async () => {
    if (!csvFile) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Please select a CSV file first"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    const selectedGroups = emailGroups.filter((g) => g.checked);
    if (selectedGroups.length === 0) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Select at least one group"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    setIsLoading(true);
    try {
      const fileBlob = await createFileBlob(
        csvFile.uri,
        csvFile.name,
        csvFile.mimeType || "text/csv",
      );

      const formData = new FormData();
      formData.append("file", fileBlob, csvFile.name);
      formData.append("groupId", selectedGroups[0].id.toString());

      const response = await axios({
        method: "post",
        url: `${EMAIL_API_BASE_URL}/emails/import/csv`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 30000,
      });

      if (
        response.data?.message === "Emails imported successfully" ||
        response.data?.imported_count >= 0
      ) {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message={`${response.data.imported_count || 0} emails imported successfully!`}
            />
          ),
          placement: "top",
          duration: 2000,
        });

        setCsvFile(null);
        setView(VIEWS.MENU);
        fetchEmailGroups();
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Error uploading CSV. Check your file format.";

      toast.show({
        render: () => (
          <Toast color={GlobalStyles.colors.red} message={errorMsg} />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const createCampaign = async (data) => {
    setIsLoading(true);
    try {
      const emailContent =
        data.content && data.content.trim().length > 0
          ? data.content.trim()
          : `<h1>${data.subject}</h1>`;

      if (data.singleEmail) {
        const createResponse = await axios.post(
          `${EMAIL_API_BASE_URL}/campaigns`,
          {
            subject: data.subject.trim(),
            content: emailContent,
            recipient_email_address: data.singleEmail.trim(),
          },
          {
            timeout: 1000,
          },
        );

        const campaignId = createResponse.data?.campaign?.id;
        if (campaignId) {
          await axios.post(
            `${EMAIL_API_BASE_URL}/campaigns/${campaignId}/send`,
            {},
            { timeout: 10000 },
          );
        }
      } else {
        const createResponses = await Promise.all(
          data.selectedGroups.map((group) =>
            axios.post(
              `${EMAIL_API_BASE_URL}/campaigns`,
              {
                subject: data.subject.trim(),
                content: emailContent,
                email_group_id: group.id,
              },
              {
                timeout: 10000,
              },
            ),
          ),
        );

        await Promise.all(
          createResponses.map((res) => {
            const id = res.data?.campaign?.id;
            if (id) {
              return axios.post(
                `${EMAIL_API_BASE_URL}/campaigns/${id}/send`,
                {},
                { timeout: 10000 },
              );
            }
          }),
        );
      }

      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.green}
            message="Campaign sent successfully!"
          />
        ),
        placement: "top",
        duration: 2000,
      });

      setView(VIEWS.MENU);
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        error.response?.data?.errors?.[0]?.msg ||
        "Error sending campaign";
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={errorMsg}
          />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteCampaign = async (campaignId) => {
    try {
      const response = await axios.delete(
        `${EMAIL_API_BASE_URL}/campaigns/${campaignId}`,
        {
          timeout: 10000,
        },
      );

      if (response.data?.message === "Campaign deleted successfully") {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message="Campaign deleted successfully!"
            />
          ),
          placement: "top",
          duration: 2000,
        });

        fetchCampaigns();
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={error.response?.data?.message || "Error deleting campaign"}
          />
        ),
        placement: "top",
        duration: 2000,
      });
    }
  };

  const createGroup = async (name) => {
    if (!name) return;

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${EMAIL_API_BASE_URL}/email-groups`,
        {
          name: name,
          description: `Group: ${name}`,
        },
        {
          timeout: 10000,
        },
      );

      if (response.data?.message === "Email group created successfully") {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message="Group created successfully!"
            />
          ),
          placement: "top",
          duration: 2000,
        });

        await fetchEmailGroups();
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={error.response?.data?.message || "Error creating group"}
          />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteGroups = async (groupsToDelete) => {
    const selectedGroups = groupsToDelete.filter((g) => g.checked);
    if (selectedGroups.length === 0) {
      return;
    }

    setIsLoading(true);
    try {
      await Promise.all(
        selectedGroups.map((group) =>
          axios.delete(`${EMAIL_API_BASE_URL}/email-groups/${group.id}`, {
            timeout: 10000,
          }),
        ),
      );

      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.green}
            message={`${selectedGroups.length} group(s) deleted successfully!`}
          />
        ),
        placement: "top",
        duration: 2000,
      });

      await fetchEmailGroups();
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={error.response?.data?.message || "Error deleting groups"}
          />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const removeEmailFromGroup = async (emailId) => {
    if (!selectedGroup?.id) return;

    try {
      const response = await axios.delete(
        `${EMAIL_API_BASE_URL}/email-groups/${selectedGroup.id}/emails/${emailId}`,
        {
          timeout: 10000,
        },
      );

      if (response.data?.message === "Email removed from group successfully") {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message="Email removed successfully!"
            />
          ),
          placement: "top",
          duration: 2000,
        });

        await fetchGroupEmails(selectedGroup.id);
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={error.response?.data?.message || "Error removing email"}
          />
        ),
        placement: "top",
        duration: 2000,
      });
    }
  };

  const handleViewDetails = (group) => {
    fetchGroupEmails(group.id);
    setView(VIEWS.GROUP_EMAIL);
  };

  const scrollToTop = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ y: 0, animated: true });
    }
  };

  const handleScroll = (event) => {
    const scrollY = event.nativeEvent.contentOffset.y;
    setShowScrollBtn(scrollY > 100);
  };
  const goHome = () => setView(VIEWS.MENU);


  return (
    <>
      <ScrollView
        ref={scrollRef}
        onScroll={handleScroll}
        scrollEventThrottle={16}
        w="100%"
        bg={GlobalStyles.colors.lightGrey}
      >
        {view === VIEWS.MENU && (
          <>
            {onBack && (
              <HStack w="100%" mb={3} mt={3} px={4}>
                <Pressable onPress={onBack}>
                  <HStack alignItems="center" space={2}>
                    <Text
                      color={GlobalStyles.colors.blue}
                      fontWeight="500"
                      fontSize={14}
                      fontFamily={GlobalStyles.text.fontFamily}
                    >
                      ← Back to Services
                    </Text>
                  </HStack>
                </Pressable>
              </HStack>
            )}
            <MainMenu
              onViewGroups={() => {
                fetchEmailGroups();
                setView(VIEWS.GROUPS);
              }}
              onAddDeleteGroup={() => {
                fetchEmailGroups();
                setView(VIEWS.ADD_DELETE);
              }}
              onAddToGroup={() => {
                fetchEmailGroups();
                setView(VIEWS.ADD_TO_GROUP);
              }}
              onSendMessages={() => {
                fetchEmailGroups();
                setView(VIEWS.SEND_MESSAGES_STEP2);
              }}
              onMessagesHistory={() => {
                fetchCampaigns();
                setView(VIEWS.MESSAGES_HISTORY);
              }}
              onGroupStats={() => {
                fetchEmailGroups();
                setView(VIEWS.GROUP_STATS);
              }}
            />
          </>
        )}

        {view === VIEWS.GROUPS && (
          <ViewGroups
            groups={emailGroups}
            onDone={() => setView(VIEWS.MENU)}
            onBack={() => setView(VIEWS.MENU)}
            isLoading={groupsLoading}
            onToggleGroup={toggleGroupSelection}
            onHome={goHome}
          />
        )}

        {view === VIEWS.ADD_DELETE && (
          <AddDeleteGroup
            groups={emailGroups}
            onDone={(payload) => {
              if (payload.name) {
                createGroup(payload.name);
              }
              deleteGroups(payload.groups);
              setView(VIEWS.MENU);
            }}
            onBack={() => setView(VIEWS.MENU)}
            isLoading={isLoading || groupsLoading}
            onToggleGroup={toggleGroupSelection}
            onHome={goHome}
          />
        )}

        {view === VIEWS.ADD_TO_GROUP && (
          <SelectEmailSource
            onNext={(selection) => {
              if (selection.single) {
                setView(VIEWS.SEND_MESSAGES_STEP1);
              } else if (selection.csv) {
                setView(VIEWS.ADD_EMAIL_CSV);
              }
            }}
            onBack={() => setView(VIEWS.MENU)}
            onHome={goHome}
          />
        )}

        {view === VIEWS.ADD_EMAIL_CSV && (
          <UploadCsv
            groups={emailGroups}
            onDone={processCSVUpload}
            onBack={() => setView(VIEWS.ADD_TO_GROUP)}
            isLoading={isLoading || groupsLoading}
            onToggleGroup={toggleGroupSelection}
            onUploadCSV={handleCSVUpload}
            onHome={goHome}
          />
        )}

        {view === VIEWS.SEND_MESSAGES_STEP1 && (
          <AddSingleEmail
            onNext={addSingleEmail}
            onBack={() => setView(VIEWS.ADD_TO_GROUP)}
            groups={emailGroups}
            isLoading={isLoading || groupsLoading}
            onToggleGroup={toggleGroupSelection}
            onHome={goHome}
          />
        )}

        {view === VIEWS.SEND_MESSAGES_STEP2 && (
          <ComposeEmail
            onBack={createCampaign}
            onGoBack={() => setView(VIEWS.MENU)}
            groups={emailGroups}
            isLoading={isLoading || groupsLoading}
            onToggleGroup={toggleGroupSelection}
            onHome={goHome}
          />
        )}

        {view === VIEWS.MESSAGES_HISTORY && (
          <MessagesHistory
            onBack={() => setView(VIEWS.MENU)}
            campaigns={campaigns}
            isLoading={campaignsLoading}
            onDeleteCampaign={deleteCampaign}
            onHome={goHome}
          />
        )}

        {view === VIEWS.GROUP_STATS && (
          <GroupStats
            onBack={() => setView(VIEWS.MENU)}
            onViewDetails={handleViewDetails}
            groups={emailGroups}
            isLoading={groupsLoading}
            onHome={goHome}
          />
        )}

        {view === VIEWS.GROUP_EMAIL && (
          <GroupEmailDetails
            selectedGroup={selectedGroup}
            onBack={() => setView(VIEWS.MENU)}
            emails={groupEmails}
            isLoading={emailsLoading}
            onRemoveEmail={removeEmailFromGroup}
            onHome={goHome}
          />
        )}
      </ScrollView>

      {showScrollBtn && (
        <IconButton
          position="absolute"
          bottom={8}
          right={8}
          borderRadius="full"
          bg={GlobalStyles.colors.blue}
          _pressed={{ bg: "gray.500" }}
          icon={<ChevronUpIcon color="white" size={6} />}
          onPress={scrollToTop}
        />
      )}
    </>
  );
};
export default CustomerData;